import css from 'styled-jsx/css'
import { colors } from '../../styles'

export default css`
 .Button {
    font-family: 'Source Sans Pro', Tahoma, sans-serif;
    font-size: 0.9em;
    color: ${colors.primaryText};
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease-in;
    font-weight: 800;
    min-width: 200px;
    padding: 10px ;
    border: 1px solid;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Button,
  .Button:active {
    color: ${colors.primaryText};
    border-color: ${colors.IconButtonPurple};
  }

  .Program-page-myList{
    align-items: center;
    padding: 12px 16px !important;
    gap: 10px;
    cursor: pointer;
    width: 100%;
    justify-content: center !important;
    height: 44px !important;
    background: ${colors.IconButtonPurple};
    border-radius: 8px;
    border: 1px solid transparent;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: #fff;
  }
  .Program-page-myList:hover,
  .Program-page-myList:focus:not(.no-focus) {
    border: 1px solid #F6F6F6;
    border-radius: 8px;
    background: #212121 !important;
  }
  .Button:hover:not(.touchable),
  .Button:focus:not(.no-focus) {

  }

  .primary-btn {
    background: ${colors.IconButtonPurple};
    border-color: ${colors.IconButtonPurple};
    margin-bottom: 15px;
  }

  .secondary-btn {
    border-color: ${colors.primaryText};
    background: transparent;
  }

  .tertiary-btn {
    border-color: ${colors.textHoverPurple};
    color: ${colors.textHoverPurple};
    background: transparent;
  }

  .player-plus {
    background: ${colors.IconButtonPurple};
    border: 0;
    color: ${colors.primaryText} !important;
    font-weight: 900;
    box-shadow: 0px 0px 12px rgba(16, 24, 32, 0.25);
    display: inline-flex;
    border-radius: 8px;
    height: 40px;
    width: 12%:
  }
.promoButton{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 32px !important;
  gap: 8px;
  background: ${colors.IconButtonPurple};
  border-radius: 8px;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 18px !important;
}
  .player-plus-banner {
    border-color: ${colors.primaryText};
    background: transparent;
    max-height: 10px;
    text-transform: none;
    min-width: 100px !important;
    border: 2px solid #F6F6F6;
    border-radius: 8px;
  }

  .out-of-region {
    background: ${colors.primaryText};
    border: 0;
    color: ${colors.black};
    font-weight: 900;
    box-shadow: 0px 0px 12px rgba(16, 24, 32, 0.25);
    display: inline-flex;
  }

  .svod-exclusive {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 32px;
    gap: 10px;
    cursor: pointer;
    width: auto;
    height: 30px;
    border-radius: 8px;
    border: 0;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 1.3em;
    line-height: 20px;
    bottom: 80px;
    box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3);
    color: ${colors.baseBg};
    background: ${colors.primaryText};
    margin-top: 8px;
    margin-bottom: 4px;
    max-width: 300px;
  }

  .player-plus:hover:not(.touchable),
  .player-plus:focus:not(.no-focus) {
    background: ${colors.darkPurple};
    color: ${colors.primaryText};
  }

  .out-of-region:hover:not(.touchable),
  .out-of-region:focus:not(.no-focus) {
    background: ${colors.IconButtonPurple};
    color: ${colors.primaryText};
  }

  .capitalize {
    text-transform: capitalize;
  }

  .icon-wrap {
    display: flex;
    margin-right: 2px;
    min-width: 16px;
  }

  .icon-wrap :global(svg){
    fill: currentColor;
  }

  .icon-wrap.tv-guide :global(svg){
    fill: ${colors.ctvBg};
  }

  .Button.anchor-btn {
    font-family: inherit;
    font-size: inherit;
    display: inline;
    border: 0;
    border-radius: 0;
    padding: 0;
    margin: 0;
    min-width: 0;
    background-color: transparent;
    color: ${colors.IconButtonPurple};
    text-transform: none;
  }

  .Button.anchor-btn:hover:not(.touchable),
  .Button.anchor-btn:focus:not(.no-focus) {
    color: ${colors.IconButtonPurple};
    background: inherit;
    border-color: inherit;
    text-decoration: underline;
  }
  .subscribe-btn {
    padding: 0.8rem;
    font-family: Source Sans Pro;
font-size: 18px;
font-weight: 400;
line-height: 21.3px;
text-align: center;
    background-color: white;
    color: black;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 1rem;
  }
  .player-plus-promo{
    display: flex;
    padding: 16px 64px !important;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 18px !important;
    height: auto;
    background: ${colors.IconButtonPurple};
  }
  .ps-button{
    display: flex;
    padding: 16px 64px !important;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 362.44px;
    height: 59.66px;
    border-radius: 8px;
    color: #151515; 
    background: white;   
  }
  .ps-button.fixed{
    width: 198px;
    height:15px;
    padding: 12px !important;
    border: none;
    margin-bottom: 0px;
  }
  .ps-button.footer{
    width:296px;
    height: 20px;
    padding: 16px !important;
    gap: 8px;
    border-radius: 8px;

  }
  .player-plus-promo:hover:not(.touchable){
    transform: scale(1.03);
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
  }
  .player-plus-promo:focus {
    background: ${colors.darkPurple};
    color: ${colors.primaryText};
  }
  .player-plus-promo.fixed{
    display:none;
  }
  .vip-button {
    margin-bottom: 42px;
    width: 295px;
    height: 14px;
    font-weight: 400;
    font-size: 18px;
    border-radius: 0px;
    border-radius: 6px;
  }
.sports-vip-button{
  width: 317px;
  padding: 0px !important;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 44px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
}
  @media (max-width: 767px) {
    .vip-button {
      max-width: 363px;
      margin-bottom: 24px;
      font-weight: 400;
      font-size: 18px;
      line-height: 20px;
    }
    .promoButton{
      width: auto !important;
    }
    .sports-vip-button{
      margin-bottom: 48px;
    }
    .player-plus-promo.optional{
      display:none;
    }
    .ps-button{
      display: none;
    }
    .ps-button.footer{
      display: flex;
      width: 192px;
      height: 38px;
      padding: 0px!important;
    }
    .ps-button.footer.fixed{
      width: 192px;
      border: none;
    }
    .player-plus-promo.fixed{
      display:flex;
      width: -webkit-fill-available;
    }
    .Program-page-myList{
    align-items: center;
    padding: 12px 32px;
    gap: 10px;
    cursor: pointer;
    width: 100%;
    height: 44px;
    background: ${colors.IconButtonPurple};
    border-radius: 8px;
    border: 0;
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: #fff;
    }
  }

  @media (min-width: 767px) {
    .Button {
      min-width: 220px;
      padding: 15px 10px;
      font-size: 1em;
    }
  }

  @media (min-width: 1024px) {
    .player-plus-banner {
      min-width: 150px !important;
    }
  }

  @media (max-width: 1200px) {
    .ps-button{
      width: 250px;
      height: 44px;
      padding: 8px !important;
    }
  }

  @media (max-width: 1024px) {
    .icon-wrap {
      position: relative;
    }

  }
`
